import React from 'react';

import { SuiContainer, SuiLabel } from '@splashthat/sui';

import {
    QUESTION_TEXT_LABEL,
    INPUT_TEXT_LABEL,
    INPUT_BACKGROUND,
    INPUT_WORD_LABEL,
} from '../../../constants/formStyleLabels';
import { COLLAPSIBLE_CONTENT, COLLAPSIBLE_SECTION } from '../../../constants/reusableClassNames';

import { TICKET_EMAIL_QA } from '../../../utils/qaIdConstants';

import QuestionTextPanel from './FormStyleEditorFormFieldsPanel/QuestionTextPanel';
import InputTextPanel from './FormStyleEditorFormFieldsPanel/InputTextPanel';
import InputBackgroundPanel from './FormStyleEditorFormFieldsPanel/InputBackgroundPanel';
import InputBorderPanel from './FormStyleEditorFormFieldsPanel/InputBorderPanel';

const SECTION_PANELS = [
    {
        panel: <QuestionTextPanel />,
        label: QUESTION_TEXT_LABEL,
        qaId: 'questionText',
    },
    {
        panel: <InputTextPanel />,
        label: INPUT_TEXT_LABEL,
        qaId: 'inputText',
    },
    {
        panel: <InputBackgroundPanel />,
        label: INPUT_BACKGROUND,
        qaId: 'inputBackground',
    },
    {
        panel: <InputBorderPanel componentLabel={INPUT_WORD_LABEL} />,
        qaId: 'border',
    },
];

const FormStyleEditorTicketEmailPanel = () => (
    <SuiContainer className={COLLAPSIBLE_CONTENT} data-qa={`${TICKET_EMAIL_QA}--panel`}>
        {SECTION_PANELS.map(({ panel, label, qaId }, index) => (
            <SuiContainer key={index} className={COLLAPSIBLE_SECTION} data-qa={`${TICKET_EMAIL_QA}--section-${qaId}`}>
                {label && <SuiLabel text={label} data-qa={`${TICKET_EMAIL_QA}--label`} />}
                {panel}
            </SuiContainer>
        ))}
    </SuiContainer>
);

export default FormStyleEditorTicketEmailPanel;
